import { render, staticRenderFns } from "./formTagsModal.vue?vue&type=template&id=5dc63e08&scoped=true"
import script from "./formTagsModal.vue?vue&type=script&lang=js"
export * from "./formTagsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc63e08",
  null
  
)

export default component.exports